var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer d-flex justify-content-center"},[_c('span',[_vm._v("Wilco Docx © "+_vm._s(_vm.currentYear)+" "),_c('a',{attrs:{"href":"http://wilcosource.com/","target":"_blank"}},[_vm._v("Wilcosource LLC")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-614f2201","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 906
// module chunks = 1